import { createTheme } from '@mui/material/styles';

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#10407B',
      light: '#4D8CC2',
      dark: '#06234C',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#DDD7D2',
      light: '#E8E2DE',
      dark: '#B8ADA8',
      contrastText: '#121212',
    },
    tertiary: {
      main: '#9E07A1',
      light: '#BE5BBF',
      dark: '#6A0371',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#B11A06',
      light: '#DB9C94',
      dark: '#5E0D00',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#FF7043',
      light: '#FFAE85',
      dark: '#D5501A',
      contrastText: '#FFFFFF',
    },
    info: {
      main: '#719BB6',
      light: '#C3D7E3',
      dark: '#40545F',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#037836',
      light: '#6BCF80',
      dark: '#005028',
      contrastText: '#FFFFFF',
    },
    divider: 'rgba(0,0,0,0.12)', // Légère séparation sombre pour un contraste doux
    text: {
      primary: '#1F1D2B',
      secondary: '#06234C',
      disabled: '#B9AEAE',
    },
    background: {
      default: '#FFFFFF',
      paper: '#F8F8F8', // Plus de profondeur avec une légère nuance
      phonecallSplitButton: '#127F79',
      note: {
        TASKCREATED: '#E1F0FA', // Bleu encore plus clair
        TASKDONE: '#A0E8A7', // Vert plus lumineux et lisible
        DEFAULT: '#E3E3E3', // Gris plus doux mais toujours visible
      },
    },
    icon: {
      tickets: {
        background: '#1698F1',
        contrast: '#FFFFFF',
      },
      tasks: {
        background: '#1698F1',
        contrast: '#FFFFFF',
      },
      messages: {
        background: '#297BA7',
        contrast: '#FFFFFF',
      },
      notes: {
        background: '#D4A713',
        contrast: '#FFFFFF',
      },
      phonecalls: {
        background: '#127F79',
        contrast: '#FFFFFF',
      },
    },
    switch: {
      messages: {
        buttonChecked: '#297BA7',
        buttonUnchecked: '#000000',
        trackChecked: '#297BA7',
        trackUnchecked: '#000000',
      },
      notes: {
        buttonChecked: '#D4A713',
        buttonUnchecked: '#000000',
        trackChecked: '#D4A713',
        trackUnchecked: '#000000',
      },
      phonecalls: {
        buttonChecked: '#127F79',
        buttonUnchecked: '#000000',
        trackChecked: '#127F79',
        trackUnchecked: '#000000',
      },
      actionOnCommand: {
        buttonChecked: '#ff7133',
        buttonUnchecked: '#000000',
        trackChecked: '#ff7133',
        trackUnchecked: '#000000',
      },
    },
    borders: {
      main: '#4D8CC2',
      light: '#A7C4D9',
      dark: '#D1D1D1',
    },
    button: {
      YUSEN: {
        main: '#3A8FC4', // Bleu principal (clair)
        hover: '#296B97', // Hover (plus foncé)
        active: '#1C4F7C', // Active (très foncé)
      },
      DPD: {
        main: '#FF8C00', // Orange doux
        hover: '#E57700', // Hover (plus foncé)
        active: '#D06000', // Active (plus profond)
      },
      UPS: {
        main: '#F6C800', // Jaune doux
        hover: '#F1B800', // Hover (plus vif)
        active: '#D79B00', // Active (plus doré)
      },
    },
  },
});

export default lightTheme;
